export default __webpack_public_path__ + "static/media/grape.56f9218f.svg";